import { loginStart, loginSuccess, loginFailure } from "./userRedux";
import { deleteProductStart, deleteProductSuccess, deleteProductFailure } from "./reduxCart";
import { publicRequest } from "../requestMethods";

export const login = async (dispatch, user) => {
    dispatch(loginStart());
    try {
        const res = await publicRequest.post("/auth/login", user);
        dispatch(loginSuccess(res.data));
    } catch (err) {
        dispatch(loginFailure());
    }
};
export const deleteProduct = async (_id, dispatch) => {
    dispatch(deleteProductStart());
    try {
        // const res = await userRequest.delete(`/products/${id}`);
        dispatch(deleteProductSuccess(_id));
    } catch (err) {
        dispatch(deleteProductFailure());
    }
};

